import React, {Component} from 'react';
import MedicalHistoryPartial from '../patientPartials/MedicalHistoryPartial';

class MedicalHistory extends Component {
  render() {
    return(
        <MedicalHistoryPartial patientId={this.props.patientId}/>
    );
  }
}

export default MedicalHistory;
